import React, { useState } from 'react';

import { ChevronDown, ChevronUp, Check } from 'lucide-react';

import { Popover, PopoverContent, PopoverTrigger, Input, Button } from '#/components/ui';
import { NUMBER_OF_DOORS_KEY } from '#/utils';

const SelectableFilterDropdown = ({
    name,
    label,
    options = [],
    selected = [],
    setSelected,
    isMulti = false,
    listSearch = false,
}) => {
    const [search, setSearch] = useState('');
    const [open, setOpen] = useState(false);

    const toggleOption = value => {
        if (isMulti) {
            if (selected.includes(value)) {
                setSelected(selected.filter(item => item !== value));
            } else {
                setSelected([...selected, value]);
            }
        } else {
            setSelected([value]);
        }
    };

    const filteredOptions = listSearch
        ? options.filter(option => option?.name?.toLowerCase()?.includes(search?.toLowerCase()))
        : options;

    if (name === NUMBER_OF_DOORS_KEY) {
        return (
            <div className='flex flex-col gap-1 px-3 pb-3'>
                {filteredOptions.map(option => {
                    const isSelected = selected.includes(option.name);
                    return (
                        <div
                            key={option.id}
                            className={`p-2 cursor-pointer rounded-md flex items-center justify-between ${
                                isSelected ? 'bg-gray200' : 'hover:bg-gray100'
                            }`}
                            onClick={() => toggleOption(option.name)}
                        >
                            <span className='text-sm font-medium'>{option.name}</span>
                            {isSelected && <Check className='w-4 h-4 text-primary' />}
                        </div>
                    );
                })}
            </div>
        );
    }

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button
                    variant='outline'
                    className='w-52 text-gray400 text-sm font-normal cursor-pointer justify-between bg-white'
                >
                    {label}
                    <span className='text-muted-foreground text-xs'>{open ? <ChevronUp /> : <ChevronDown />}</span>
                </Button>
            </PopoverTrigger>

            <PopoverContent className='w-52 max-h-80 overflow-auto p-2 bg-white'>
                {listSearch && (
                    <Input
                        placeholder={`Search ${label}`}
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        className='mb-2 placeholder:text-gray400'
                    />
                )}

                <div className='space-y-1'>
                    {filteredOptions.map(option => {
                        const isSelected = selected.includes(option.name);
                        return (
                            <div
                                key={option.id}
                                className={`p-2 cursor-pointer rounded-md flex hover:bg-gray200 items-center justify-between ${
                                    isSelected ? 'bg-gray200' : 'bg-white'
                                }`}
                                onClick={() => toggleOption(option.name)}
                            >
                                <span className='text-sm font-medium capitalize'>{option.name}</span>
                                {isSelected && <Check className='w-4 h-4 text-primary' />}
                            </div>
                        );
                    })}
                </div>
            </PopoverContent>
        </Popover>
    );
};

export { SelectableFilterDropdown };
